import CheckmateApiClient from '../../../../services/apiClient';
import { ISaveSameCaseModel } from '../../../../interfaces/ISameCaseModel';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useSaveSameCaseMutation = () => {
    return useMutation({
        mutationFn: async (saveModel: ISaveSameCaseModel) => {
            const response = await _apiClient.saveSameCase(saveModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                if ((response.httpResponse.status == 400 && response.errors?.length) ?? 0 > 0) {
                    throw new Error(`Failed to update case group: ${response.errors[0]}`);
                }
                throw new Error('Failed to update case group');
            }

            return response.payload;
        },
    });
};
